import { AddGeofenceComponent } from "./add-geofence/add-geofence.component";
import { EditGeofenceComponent } from "./edit-geofence/edit-geofence.component";
import { ViewGeofenceComponent } from "./view-geofence/view-geofence.component";

export const GeofenceModuleDeclaration = [
    AddGeofenceComponent,
    EditGeofenceComponent,
    ViewGeofenceComponent
];